var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex justify-center align-center py-2"},[_c('img',{attrs:{"src":_vm.templateItemData.icon,"alt":"DNS protect","width":_vm.iconWidth,"height":_vm.iconHeight}})])}
var staticRenderFns = []

export { render, staticRenderFns }